import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { Heading, Text } from '../../mo-gel';
import {
  StyledContainer,
  StyledHeadingContainer,
  StyledTextContainer,
  StyledButton,
  StyledButtonContents
} from './HowItWorks.styled';

import { Timeline } from '../Timeline/Timeline';
import { ReactComponent as RightArrow } from '../../images/icons/right_icon.svg';

interface TimelineHeading {
  heading: string;
  text: string;
}

interface HowItWorksProps {
  content: {
    heading: string;
    text: string;
    timelineHeadings: TimelineHeading[];
  };
  numberOfTimelineComponents: number;
}

export const HowItWorks = ({ content, numberOfTimelineComponents }: HowItWorksProps) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const goToContact = () => {
    navigate('/contact');
  };

  return (
    <StyledContainer>
      <StyledTextContainer>
        <StyledHeadingContainer>
          <Heading level="h3" color={theme.colors.content} marginBottom="20px">
            {content.heading}
          </Heading>
        </StyledHeadingContainer>
        <Text as="p" display="block" color={theme.colors.content}>
          {content.text}
        </Text>
      </StyledTextContainer>
      <Timeline numberOfTimelineComponents={numberOfTimelineComponents} timelineHeadings={content.timelineHeadings} />
      <StyledButton primary={true} width="161px" onClick={goToContact}>
        <StyledButtonContents>
          Sign Up
          <RightArrow />
        </StyledButtonContents>
      </StyledButton>
    </StyledContainer>
  );
};
